import React, { useEffect } from 'react';
import { StaticImage } from '../../utils/image';
import Meanlawdetail from './meanlawdetail';
import Meanlawsubbranner from './meanlawsubbranner';
import Meansection from './meansection';
import Meansection2 from './meansection2';
import Meansection3 from './meansection3';
import { isMobile } from 'react-device-detect';
const MeanLaw = () => {
  useEffect(() => {
    document.title = 'ระบบกลางกฎหมาย คือ';
    return () => {};
  }, []);

  return (
    <div
      // className='section-banner'
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: isMobile ? 25 : 60,
      }}
    >
      {/* <img
        className='section-sub-branner-image-section2'
        src={StaticImage('/images/branner/rectangle-1@3x.png')}
      /> */}
      <img
        style={{ width: '100%', maxWidth: 500 }}
        src={StaticImage('/images/M-SC66-merge.jpg')}
      />
      {/* <section>
        <Meanlawsubbranner />
      </section>
      <section>
        <Meanlawdetail />
      </section>
      <section>
        <Meansection />
      </section>
      <section>
        <Meansection2 />
      </section>
      <section>
        <Meansection3 />
      </section> */}
    </div>
  );
};

export default MeanLaw;
